import { loaderSlice } from '../store/slices/loaderSlice';

export const { showLoader: showLoaderAction, hideLoader: hideLoaderAction } = loaderSlice.actions;
